<template>
  <div>
    <Header :selectedApp="selectedApp"></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Paypal Configurations</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input type="text" class="form-control mb-3" placeholder="Search Paypal Configurations..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('paypalName')">Paypal Name</th>
              <th class="col-1" @click="toggleSort('brandName')">Brand Name</th>
              <th class="col-1" @click="toggleSort('clientId')">Client Id</th>
              <th class="col-1" @click="toggleSort('clientSecret')">Client Secret</th>
              <th class="col-1" @click="toggleSort('webhookId')">Webhook id</th>
              <th class="col-1" @click="toggleSort('apiBase')">API Base</th>
              <th class="col-1" @click="toggleSort('redirectUrl')">Redirect URL</th>
              <th class="col-1" @click="toggleSort('application')">Application</th>
              <th class="col-1" @click="toggleSort('percentage')">Percentage</th>
              <th class="col-1" @click="toggleSort('active')">Active</th>
              <th class="col-1" @click="toggleSort('status')">Status</th>
              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.paypalConfigurationId">
              <td class="col-1 text-truncate" v-html="truncateText(config.paypalName, 30)" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.brandName, 30)" @click="selectText" :data-text="config.brandName"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.clientId, 30)" @click="selectText" :data-text="config.clientId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.clientSecret, 30)" @click="selectText" :data-text="config.clientSecret"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.webhookId, 30)" @click="selectText" :data-text="config.webhookId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.apiBase, 30)" @click="selectText" :data-text="config.apiBase"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.redirectUrl, 30)" @click="selectText" :data-text="config.redirectUrl"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.application, 30)" @click="selectText" :data-text="config.application"></td>
              <td class="col-1 text-truncate">{{ config.percentage }}%</td>
              <td class="col-1 text-truncate">{{ config.active }}</td>
              <td class="col-1 text-truncate">{{ config.status }}</td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'PaypalEdit', params: { id: config.paypalConfigurationId, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <p class="text-muted mt-2">
          Percentage, Active and Status are set on the
          <router-link :to="{ name: 'PaymentManagement' }">Payment Management</router-link> page, not here —
          that's also where an account is activated/deactivated.
        </p>

      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import Cookies from "js-cookie";

export default {
  name: "PaypalConfig",
  components: {
    Header,
  },
  data() {
    return {
      searchText: '',
      paypalConfigList: [],
      sortColumn: '',  // Add this property
      sortDirection: 'asc',
      selectedApp: ''
    };
  },
  computed: {
    filteredPaypalConfigList() {
      const search = this.searchText.toLowerCase().trim();
      let filteredList = this.paypalConfigList.filter((config) => {
        return (
            (config.paypalName && config.paypalName.toLowerCase().includes(search)) ||
            (config.brandName && config.brandName.toLowerCase().includes(search)) ||
            (config.clientId && config.clientId.toLowerCase().includes(search)) ||
            (config.clientSecret && config.clientSecret.toLowerCase().includes(search)) ||
            (config.webhookId && config.webhookId.toLowerCase().includes(search)) ||
            (config.apiBase && config.apiBase.toLowerCase().includes(search)) ||
            (config.redirectUrl && config.redirectUrl.toLowerCase().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn].toLowerCase();
          const valueB = b[this.sortColumn].toLowerCase();

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      //Sort the table to include only the elements that have the selected application
      if (this.selectedApp !== '') {
        filteredList = filteredList.filter(item => item.application === this.selectedApp);
      }
      return filteredList;
    },
    sortData() {
      return this.filteredPaypalConfigList;
    },
  },
  created() {
    this.doLoadPaypalConfig();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    const appCookie = Cookies.get('application');
    if (appCookie) {
      this.selectedApp = appCookie;
    }

    this.sortColumn = 'paypalName';
  },
  methods: {
    doLoadPaypalConfig() {
      AdminService.getPaypalConfigurationList()
          .then((data) => {
            this.paypalConfigList = data;
          })
          .catch((error) => {
            console.error("Error loading Paypal configuration:", error);
          });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    redirectToCreate() {
      this.$router.push({ name: 'PaypalCreate' }); // Navigate to the PaypalEdit route without params
    },
    truncateText(text, limit) {
      if (text === undefined || text ===null) {
        return null
      } else {
        return text.length > limit ? text.substring(0, limit) + '...' : text;
      }
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    async selectRow(event) {
      var td = event.target;
      var tr = td.parentNode;

      // Remove 'selected' class from all rows
      var rows = document.getElementsByTagName('tr');
      for (var i = 0; i < rows.length; i++) {
        rows[i].classList.remove('selected');
      }

      // Add 'selected' class to clicked row
      tr.classList.add('selected');
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    highlightRow(event) {
      // Remove highlight from all rows
      document.querySelectorAll('tr').forEach(row => {
        row.style.backgroundColor = '';
      });

      // Add highlight to clicked row
      event.target.parentNode.style.backgroundColor = 'yellow';
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
   toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },
  },
};
</script>
<style src="../../assets/style.css">
</style>